import * as React from 'react'
import { VariantProps, cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import { Button as DesigConfigButton } from 'design-configuration/components'

const textButtonVariants = cva(
  'inline-flex items-center justify-center gap-2xs font-founders relative transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-primary disabled:opacity-50 disabled:pointer-events-none ring-offset-background',
  {
    variants: {
      colorTheme: {
        default: 'text-on-surface text-lg hover:text-on-surface',
        subtle: 'text-on-surface-variant text-xs hover:text-on-surface',
        emphasis: 'text-on-surface-variant text-xs font-medium uppercase hover:text-on-surface'
      }
    },
    defaultVariants: {
      colorTheme: 'default'
    }
  }
)

interface TextButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof textButtonVariants> {
  asChild?: boolean
  iconLeft?: React.ReactElement
  iconRight?: React.ReactElement
}

const TextButton = React.forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ colorTheme, className, iconLeft, iconRight, ...props }: TextButtonProps, ref) => {
    return (
      <DesigConfigButton className={cn(textButtonVariants({ colorTheme }), className)} ref={ref} {...props}>
        {iconLeft ? <span className="flex items-center">{iconLeft}</span> : null}
        <span>{props.children}</span>
        {iconRight ? <span className="flex items-center">{iconRight}</span> : null}
      </DesigConfigButton>
    )
  }
)
TextButton.displayName = 'Button'

export { TextButton, textButtonVariants }
